"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const constants_1 = require("../constants");
const LoginScreen_1 = __importDefault(require("./LoginScreen"));
const PasswordScreen_1 = __importDefault(require("./PasswordScreen"));
const SuccessScreen_1 = __importDefault(require("./SuccessScreen"));
const AppContextProvider_1 = require("../contexts/AppContextProvider");
const VerifyScreen_1 = __importDefault(require("./VerifyScreen"));
const OtpScreen_1 = __importDefault(require("./OtpScreen"));
const RegistrationScreen_1 = __importDefault(require("./RegistrationScreen"));
const styled_components_1 = require("styled-components");
const ForgotPasswordScreen_1 = __importDefault(require("./ForgotPasswordScreen"));
const ResetPasswordScreen_1 = __importDefault(require("./ResetPasswordScreen"));
const ChangePasswordScreen_1 = __importDefault(require("./ChangePasswordScreen"));
const EditMobileNumberScreen_1 = __importDefault(require("./EditMobileNumberScreen"));
const ConfirmationScreen_1 = __importDefault(require("./ConfirmationScreen"));
const FailureScreen_1 = __importDefault(require("./FailureScreen"));
const OtpDeepLink_1 = __importDefault(require("./OtpScreen/OtpDeepLink"));
const CompleteRegistrationScreen_1 = __importDefault(require("./CompleteRegistrationScreen"));
const InCompleteProfileInfoScreen_1 = __importDefault(require("./InCompleteProfileInfoScreen"));
const react_2 = require("react");
const Modal = (0, react_2.lazy)(() => Promise.resolve().then(() => __importStar(require("../componentReusable/Dialog"))));
const SsoFlow = ({ setIsSsoModalOpen }) => {
    const { flowState } = (0, AppContextProvider_1.useSsoContext)();
    const { isDesktop, isMobile } = (0, styled_components_1.useTheme)();
    const getScreen = () => {
        switch (flowState.screenType) {
            case constants_1.ScreenConstants.LOGIN_SCREEN:
                return (0, jsx_runtime_1.jsx)(LoginScreen_1.default, { setIsSsoModalOpen: setIsSsoModalOpen });
            case constants_1.ScreenConstants.RETURNING_USER:
                return (0, jsx_runtime_1.jsx)(PasswordScreen_1.default, {});
            case constants_1.ScreenConstants.LOGIN_SUCCESS:
                return (0, jsx_runtime_1.jsx)(SuccessScreen_1.default, { setIsSsoModalOpen: setIsSsoModalOpen });
            case constants_1.ScreenConstants.NEW_USER:
                return (0, jsx_runtime_1.jsx)(VerifyScreen_1.default, {});
            case constants_1.ScreenConstants.VERIFY_VIA_OTP:
                return (0, jsx_runtime_1.jsx)(OtpScreen_1.default, {});
            case constants_1.ScreenConstants.REGISTER_NEW_USER:
                return (0, jsx_runtime_1.jsx)(RegistrationScreen_1.default, {});
            case constants_1.ScreenConstants.FORGOT_PASSWORD:
                return (0, jsx_runtime_1.jsx)(ForgotPasswordScreen_1.default, {});
            case constants_1.ScreenConstants.NEW_PASSWORD:
                return (0, jsx_runtime_1.jsx)(ResetPasswordScreen_1.default, {});
            case constants_1.ScreenConstants.CHANGE_PASSWORD:
                return (0, jsx_runtime_1.jsx)(ChangePasswordScreen_1.default, {});
            case constants_1.ScreenConstants.CHANGE_PHONE_NUMBER:
                return (0, jsx_runtime_1.jsx)(EditMobileNumberScreen_1.default, {});
            case constants_1.ScreenConstants.CONFIRMATION_SCREEN:
                return (0, jsx_runtime_1.jsx)(ConfirmationScreen_1.default, { setIsSsoModalOpen: setIsSsoModalOpen });
            case constants_1.ScreenConstants.ERROR_SCREEN:
                return (0, jsx_runtime_1.jsx)(FailureScreen_1.default, {});
            case constants_1.ScreenConstants.VERIFY_VIA_OTP_LINK:
                return (0, jsx_runtime_1.jsx)(OtpDeepLink_1.default, {});
            case constants_1.ScreenConstants.COMPLETE_USER_PROFILE_INFO:
                return (0, jsx_runtime_1.jsx)(InCompleteProfileInfoScreen_1.default, { setIsSsoModalOpen: setIsSsoModalOpen });
            case constants_1.ScreenConstants.COMPLETE_REGISTER:
                return ((0, jsx_runtime_1.jsx)(CompleteRegistrationScreen_1.default, { setIsSsoModalOpen: setIsSsoModalOpen }));
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Suspense, Object.assign({ fallback: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) }, { children: (0, jsx_runtime_1.jsx)(Modal, Object.assign({ open: true, onClose: null, isFullScreen: !(isDesktop && (flowState.screenType === constants_1.ScreenConstants.LOGIN_SCREEN || flowState.screenType === constants_1.ScreenConstants.COMPLETE_USER_PROFILE_INFO)), setIsSsoModalOpen: setIsSsoModalOpen, modalKey: flowState.screenType, isBottom: flowState.screenType === constants_1.ScreenConstants.COMPLETE_REGISTER && isMobile }, { children: getScreen() })) })));
};
exports.default = SsoFlow;
